import React, { Suspense, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Layout from "../components/Layout";
import Particle from "../components/Particle";
import Socialicons from "../components/Socialicons";
import Spinner from "../components/Spinner";
import config from "../config";

function Home() {
  // const [information, setInformation] = useState("");

  // useEffect(() => {
  //   fetch(`${config.apiUrl}${config.apiBasePath}information`, {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'x-Api-Key': config.apiKey
  //     }
  //   })
  //     .then(response => {
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }
  //       return response.json();
  //     })
  //     .then(data => {
  //       setInformation(data);
  //     })
  //     .catch(error => {
  //       console.error('Error fetching information:', error);
  //     });
  // }, []);

  return (
    <Layout>
      <Helmet>
        <title>Home - Adrian Callies Portfolio</title>
        <meta
          name="description"
          content="Adrian Callies - Software Engineer Portfolio Homepage"
        />
      </Helmet>
      <Suspense fallback={<Spinner />}>
        <div className="mi-home-area mi-padding-section">
          <Particle />
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10 col-12">
                <div className="mi-home-content">
                  <h1>
                    Hi, I am <span className="color-theme">Adrian Callies</span>
                  </h1>
                  <p>I am a software engineer, who provides clean code that is optimal but simple. I build dynamic applications to serve people's needs in a world that is technologically changing...</p>
                  <Socialicons bordered />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Suspense>
    </Layout>
  );
}

export default Home;
